import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const AddButton = ({ handleClick }) => (
  <Button
    onClick={handleClick}
    className="btn btn-light btn-add-question d-flex justify-content-center align-items-center"
  >
    <FontAwesomeIcon icon="plus" className="d-none d-lg-flex" />
    Add Question
  </Button>
);

const RearrrangeButton = ({ rearrangeMode, handleClick }) => (
  <Button
    onClick={handleClick}
    className="btn btn-light btn-add-question d-flex justify-content-center align-items-center"
    style={{ backgroundColor: '#afafaf' }}
  >
    <FontAwesomeIcon icon="arrows-alt" className="d-none d-lg-flex" />
    {rearrangeMode ? 'Save' : 'Re-arrange Mode'}
  </Button>
);

const ActionButtons = ({ rearrangeMode, toggleAdd, handleQuestionArrange }) => (
  <div className="d-flex flex-row justify-content-between justify-content-lg-end action-buttons">
    {!rearrangeMode && <AddButton handleClick={toggleAdd} />}
    <RearrrangeButton
      handleClick={handleQuestionArrange}
      rearrangeMode={rearrangeMode}
    />
  </div>
);

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/components/customSurvey/questions/actionButtons.js